import Marquee from "react-fast-marquee";
import Hero from "../components/home/Hero";
import Expertise from "../components/home/Expertise";
import ChantiersCarousel from "../components/home/ChantiersCarousel";
import HomeProjects from "../components/home/HomeProjects";
import Method from "../components/home/Method";
import Engagements from "../components/home/Engagements";
import HomeVideo from "../components/home/HomeVideo";
import FinalCTA from "../components/home/FinalCTA";
import BeforeAfter from "../components/BeforeAfter";
import { Reveal } from "../lib/reveal";
import { useSEO, useJsonLd, SITE_URL } from "../lib/seo";
import { COMPANY } from "../data/content";

const MARQUEE_ITEMS = [
  "Rénovation complète",
  "Couverture & zinc",
  "Structure acier",
  "Ouvertures de murs porteurs",
  "Rénovation énergétique",
  "Verrières sur mesure",
  "Terrasses & extérieurs",
  "Salles de bains",
];

const HomePage = () => {
  useSEO(
    "BÂTI 360 — Rénovation tous corps d'état à Paris & Île-de-France",
    "Entreprise générale de rénovation à Paris et en Île-de-France : rénovation d'appartements et maisons, structure, couverture zinc, isolation, métallerie. Devis gratuit."
  );
  useJsonLd({
    "@context": "https://schema.org",
    "@type": "GeneralContractor",
    name: "BÂTI 360",
    telephone: "+33757513375",
    email: "contact@bati360.com",
    url: SITE_URL,
    image: `${SITE_URL}/logo-full.webp`,
    address: {
      "@type": "PostalAddress",
      streetAddress: "Avenue Roland Moreno",
      postalCode: "77124",
      addressLocality: "Chauconin-Neufmontiers",
      addressCountry: "FR",
    },
    areaServed: ["Paris", "Île-de-France"],
    sameAs: [
      "https://www.instagram.com/bati.360",
      "https://www.facebook.com/share/1CAMa3rpFU/",
      "https://www.linkedin.com/in/william-quinteiro-949388b2",
    ],
  });

  return (
    <>
      <Hero />

      <div className="overflow-hidden border-y border-black/10 bg-white py-5" data-testid="marquee-band">
        <Marquee speed={28} gradient={false} pauseOnHover>
          {MARQUEE_ITEMS.map((item) => (
            <span key={item} className="mx-8 flex items-center gap-16 font-display text-sm font-bold uppercase tracking-[0.22em] text-bati-ink/40">
              {item}
              <span className="h-1.5 w-1.5 bg-bati-sky" />
            </span>
          ))}
        </Marquee>
      </div>

      <Expertise />
      <ChantiersCarousel />
      <HomeProjects />
      <Method />
      <Engagements />
      <HomeVideo />

      <section data-testid="before-after-section" className="bg-white py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="mb-12 grid gap-8 lg:grid-cols-2 lg:items-end">
            <Reveal>
              <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
                <span className="h-px w-10 bg-bati-sky" /> La preuve par l'image
              </p>
              <h2 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink sm:text-5xl">Avant / Après</h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="max-w-lg text-base leading-relaxed text-bati-ink/60 lg:ml-auto">
                Faites glisser le curseur pour comparer cette maison avant les travaux et après sa surélévation et sa rénovation complète par BÂTI 360 — le même chantier, sous le même angle.
              </p>
            </Reveal>
          </div>
          <Reveal>
            <BeforeAfter
              before="/chantiers/surelevation/avant-16x10.webp"
              after="/chantiers/surelevation/apres-16x10.webp"
              className="aspect-[16/10] w-full md:aspect-[16/8]"
            />
          </Reveal>
        </div>
      </section>

      <FinalCTA />
    </>
  );
};

export default HomePage;
